import React, { useState } from 'react';

import { JOKI } from '../../../JOKI';
// import { DataTable } from '@storaensods/-react';
import DataTable from '../../DataTable2/DataTable';
import moment from 'moment';

import ConfirmButton from '../../ConfirmButton/ConfirmButton';

import './DeviceAlarmTable.scss';
import Spinner from 'selfly-ui-react/dist/components/Spinner';

export default function DeviceAlarmTable(props) {
    const [cancelling, setCancelling] = useState({});

    function onCancelAlarm(alarmId) {
        const alertData = props.alarms.find(alarm => alarm.id === alarmId);
        setCancelling(prev => {
            const newCancels = { ...prev };
            newCancels[alarmId] = true;
            return newCancels;
        });
        JOKI.trigger({
            to: 'AlertsService',
            key: 'closeAlert',
            body: {
                alert: alertData,
                device: props.device,
            },
        });
        // props.dispatch(cancelDeviceAlarmManually(alarmData, props.device));
    }

    const { alarms } = props;

    const columns = [
        {
            key: 'severity',
            header: 'Severity',
            content: (sev, item) => {
                const sevLevel = getAlarmSeverityLevel(sev);
                switch (sevLevel) {
                    case 'oos':
                        return <span className="device-alarm-severity oos">Oos</span>;
                    case 'urgent':
                        return <span className="device-alarm-severity urgent">Urgent</span>;
                    case 'critical':
                        return <span className="device-alarm-severity critical">Critical</span>;
                    case 'informative':
                        return <span className="device-alarm-severity informative">Informative</span>;
                    default:
                    case 'note':
                        return <span className="device-alarm-severity note">Note</span>;
                }
            },
            width: '140px',
        },
        {
            key: 'triggerCounter',
            header: 'Count',
            className: 'large-cell-text hide-in-responsive',
            width: '100px',
            headerClassName: 'hide-in-responsive',
        },
        {
            key: 'source',
            header: 'Source',
            width: '120px',
        },
        {
            key: 'type',
            header: 'Type',
            width: '120px',
        },
        {
            key: 'firstTimeSeen',
            header: 'First seen',
            content: value => {
                if (value === null || value === undefined || value === '') return null;
                return moment(value).format('D.M.YYYY HH:mm');
            },
            width: '130px',
            className: 'hide-in-responsive',
            headerClassName: 'hide-in-responsive',
        },
        {
            key: 'lastTimeSeen',
            header: 'Last seen',
            content: value => {
                if (value === null || value === undefined || value === '') return null;
                return moment(value).format('D.M.YYYY HH:mm');
            },
            width: '130px',
        },
        {
            key: 'description',
            header: 'Description',
            className: 'hide-in-responsive',
            headerClassName: 'hide-in-responsive',
        },
    ];

    if (props.cancelAlarms === true) {
        columns.push({
            header: 'Actions',
            sorting: false,
            key: alarm => {
                if (alarm.state === 'ACTIVE' && cancelling[alarm.id] !== true) {
                    const confirmText = `You are about to cancel a ${getAlarmSeverityLevel(alarm.severity)} '${alarm.type}' alarm from '${
                        alarm.source
                    }'.\nPlease press confirm to cancel the alarm.`;
                    return (
                        <ConfirmButton icon="delete" type="negative" size="sm" onClick={() => onCancelAlarm(alarm.id)} modalContent={confirmText}>
                            Cancel
                        </ConfirmButton>
                    );
                }
                if (cancelling[alarm.id] === true) {
                    return (
                        <span>
                            <Spinner /> Cancelling
                        </span>
                    );
                }
                return '';
            },
        });
    }

    if (alarms.length === 0) {
        return <h2 className="no-alarms">No alarms!</h2>;
    }

    return <DataTable className="device-alarm-table" data={alarms} columns={columns} />;
}

function getAlarmSeverityLevel(severity) {
    if (severity > 0.99) return 'oos';
    if (severity >= 0.89) return 'urgent';
    if (severity >= 0.79) return 'critical';
    if (severity >= 0.59) return 'informative';
    return 'note';
}
